/* Black Week 2026 · Script der Landingpage-Section bw-hero. */
(function () {
  if (window.__bwLoaded) return;
  window.__bwLoaded = true;

  var DEFAULT_SWITCH = '2026-11-19T18:00:00+01:00';
  var UTM_KEY = 'bfc_bw_utm';
  var UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var KLAVIYO = 'https://a.klaviyo.com/client/';
  var HEADERS = { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' };

  function captureUtm() {
    try {
      var p = new URLSearchParams(window.location.search), found = {}, any = false;
      UTM_FIELDS.forEach(function (f) { var v = p.get(f); if (v) { found[f] = v.slice(0, 120); any = true; } });
      if (p.get('fbclid')) { found.fbclid = 'ja'; any = true; }
      if (any) sessionStorage.setItem(UTM_KEY, JSON.stringify(found));
    } catch (e) {}
  }
  function readUtm() { try { return JSON.parse(sessionStorage.getItem(UTM_KEY)) || {}; } catch (e) { return {}; } }
  captureUtm();

  /* Umschaltzeit und Modus kommen aus der Section-Einstellung, sonst Standard */
  function settings() {
    var root = document.querySelector('[data-bw-root]');
    return {
      mode: root ? root.getAttribute('data-bw-mode') : 'auto',
      at: (root && root.getAttribute('data-bw-switch')) || DEFAULT_SWITCH,
      editorSuccess: !!(root && root.hasAttribute('data-editor-success'))
    };
  }
  function isSale(cfg) {
    if (cfg.mode === 'sale') return true;
    if (cfg.mode === 'lead') return false;
    var t = Date.parse(cfg.at);
    return !isNaN(t) && Date.now() >= t;
  }

  function post(path, key, body) {
    return fetch(KLAVIYO + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST', keepalive: true, headers: HEADERS, body: JSON.stringify(body)
    }).then(function (res) { if (!res.ok) throw new Error('status ' + res.status); return res; });
  }

  function initForm(wrap, cfg) {
    if (wrap.dataset.bwInit) return;
    wrap.dataset.bwInit = '1';
    var form = wrap.querySelector('[data-bw-form]');
    var success = wrap.querySelector('[data-bw-success]');
    var errorBox = wrap.querySelector('[data-bw-error]');
    var showError = function (msg) { if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } };
    var showSuccess = function () {
      wrap.dataset.bwDone = '1';
      if (form) form.hidden = true;
      if (success) { success.hidden = false; success.focus({ preventScroll: true }); }
    };
    if (cfg.editorSuccess) { showSuccess(); return; }
    if (!form) return;

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (form.dataset.bwSending) return;
      if (errorBox) errorBox.hidden = true;

      var firstField = form.querySelector('[name="first_name"]');
      var emailField = form.querySelector('[name="email"]');
      var firstName = firstField ? firstField.value.trim() : '';
      var email = emailField ? emailField.value.trim() : '';
      if (!firstName) { showError('Bitte gib deinen Vornamen ein.'); firstField.focus(); return; }
      if (!email || (emailField.checkValidity && !emailField.checkValidity())) {
        showError('Bitte gib eine gültige E-Mail-Adresse ein.');
        emailField.focus();
        return;
      }

      var key = wrap.getAttribute('data-klaviyo-key');
      var listId = wrap.getAttribute('data-list-id');
      if (!key || !listId || !window.fetch) { showError('Die Anmeldung ist gerade nicht möglich. Bitte versuch es später noch einmal.'); return; }

      var utm = readUtm();
      var eventId = 'bw-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);

      /* 1. Liste mit Newsletter-Einwilligung (Double-Opt-in kommt von Klaviyo) */
      var subscription = { data: { type: 'subscription', attributes: {
        custom_source: 'Landingpage Black Week 2026',
        profile: { data: { type: 'profile', attributes: {
          email: email
        } } }
      }, relationships: { list: { data: { type: 'list', id: listId } } } } };

      /* 2. Event mit Vorname und UTM-Quelle am Profil */
      var profileProps = { black_week_2026_vorab: true };
      if (utm.utm_source) profileProps.black_week_2026_utm_source = utm.utm_source;
      if (utm.utm_campaign) profileProps.black_week_2026_utm_campaign = utm.utm_campaign;
      if (utm.utm_content) profileProps.black_week_2026_utm_content = utm.utm_content;
      var event = { data: { type: 'event', attributes: { unique_id: eventId,
        properties: Object.assign({ Quelle: 'Landingpage Black Week', event_id: eventId }, utm),
        metric: { data: { type: 'metric', attributes: { name: 'Black Week Vorab-Anmeldung' } } },
        profile: { data: { type: 'profile', attributes: { email: email, first_name: firstName, properties: profileProps } } }
      } } };

      form.dataset.bwSending = '1';
      var btn = form.querySelector('[data-bw-submit]');
      if (btn) btn.disabled = true;

      post('subscriptions', key, subscription).then(function () {
        post('events', key, event).catch(function () { setTimeout(function () { post('events', key, event).catch(function () {}); }, 2000); });
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('black_week_lead', Object.assign({ event_id: eventId }, utm));
          }
        } catch (e) {}
        showSuccess();
      }).catch(function () {
        delete form.dataset.bwSending;
        if (btn) btn.disabled = false;
        showError('Das hat leider nicht geklappt. Bitte versuch es noch einmal.');
      });
    });
  }

  /* Dezenter Hinweis: „Noch x Tage bis zum Vorab-Zugang“ */
  function initCountdown(cd, cfg, sale) {
    var at = new Date(cfg.at);
    if (sale || isNaN(at)) { cd.hidden = true; return; }
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var target = new Date(at.getFullYear(), at.getMonth(), at.getDate());
    var days = Math.round((target - today) / 86400000);
    var text = '';
    if (days > 1) text = (cd.getAttribute('data-label') || 'Noch [x] Tage').replace('[x]', days);
    else if (days === 1) text = 'Morgen ab 18 Uhr';
    else if (days === 0) text = 'Heute ab 18 Uhr';
    cd.textContent = text;
    cd.hidden = !text;
  }

  function boot() {
    var cfg = settings();
    var sale = isSale(cfg);
    document.querySelectorAll('.bw [data-bw-when]').forEach(function (el) {
      if (el.hasAttribute('data-bw-countdown')) return;
      el.hidden = el.getAttribute('data-bw-when') === 'sale' ? !sale : sale;
    });
    document.querySelectorAll('[data-bw-countdown]').forEach(function (cd) { initCountdown(cd, cfg, sale); });
    document.querySelectorAll('[data-bw-form-wrap]').forEach(function (w) { initForm(w, cfg); });
    document.querySelectorAll('.bw-hero video').forEach(function (vid) {
      vid.muted = true;
      /* Tempo aus dem Slider „Video-Tempo“ (0.1–1) */
      var media = vid.closest('[data-bw-speed]');
      var speed = media ? parseFloat(media.getAttribute('data-bw-speed')) : 1;
      if (speed > 0 && speed <= 1) {
        vid.defaultPlaybackRate = speed;
        vid.playbackRate = speed;
        if (!vid.dataset.bwSpeed) { vid.dataset.bwSpeed = '1'; vid.addEventListener('loadedmetadata', function () { vid.playbackRate = speed; }); }
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { vid.removeAttribute('autoplay'); vid.pause(); }
      else { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () { setTimeout(boot, 0); });
})();
